import {DxButtonModule, DxGanttModule, DxLookupModule} from 'devextreme-angular';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProjectGanttViewComponent} from './project-gantt-view/project-gantt-view.component';
import {TaskPopupModule} from 'src/app/pages/task/task-popup/task-popup.module';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';

@NgModule({
	declarations: [ProjectGanttViewComponent],
	exports: [ProjectGanttViewComponent],
	imports: [
		CommonModule,
		DxGanttModule,
		DxLookupModule,
		TaskPopupModule,
		DxButtonModule,
		DxTableControllerDirective,
	],
})
export class ProjectGanttViewModule {}
